<template>
  <el-select v-model="valueTemp"
             :placeholder="placeholder"
             :clearable="clearable"
             :filterable="filterable"
             :disabled="disabled"
             :size="size"
             style="width: 100%">
    <el-option v-for="item in data"
               :key="item.pk"
               :label="item.name"
               :value="item.pk">
    </el-option>
  </el-select>
</template>

<script>
import * as curApi from "@/api/base/corp";

export default {
  name: "EspCorp",
  data() {
    return {
      valueTemp: this.value,
      data: []
    }
  },
  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    placeholder: {
      type: String,
      default: "请选择"
    }
  },
  methods: {
    doLoadData: function () {
      curApi.list({searchParam: {isSeal: "N"}}).then(res => {
        if (res.data) {
          this.data = res.data;
        } else {
          this.data = [];
        }
      }).catch(error => {
      });
    }
  },
  created: function () {
    this.doLoadData();
  },
  watch: {
    valueTemp: {
      handler(newVal, oldVal) {
        if (newVal == "") {
          this.$emit("input", null);
          this.$emit("change", null);
          if (!(oldVal == undefined || oldVal == null || oldVal == "")) {
            this.$emit("afterSelect", newVal);
          }
        } else {
          this.$emit("input", newVal);
          this.$emit("change", newVal);
          if (!(oldVal == undefined || oldVal == null || oldVal == "")) {
            this.$emit("afterSelect", newVal);
          }
        }
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(newVal, oldVal) {
        this.valueTemp = this.value;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/corp/EspCorp.vue